export function globalResponseAdd({autoClose, error, success}) {
    return (dispatch) => {
        dispatch({type: 'GLOBAL_RESPONSE_ADD', autoClose, error, success});
    };
}
export function globalResponseReset() {
    return (dispatch) => {
        dispatch({type: 'GLOBAL_RESPONSE_RESET'});
    };
}
